<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">عناوین درسی</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>

    <div class="p-3">
      <div class="bg_white rounded-4 shadow-sm w-100 mb-4">
        <div class="d-flex align-items-center justify-content-center">
          <div 
            class="w-50 text-center py-3 cursor-pointer position-relative"
            @click="activeTab = 'incomplete'"
          >
            <span :class="activeTab === 'incomplete' ? 'text_color_theme bold' : 'text_color_gray'">مضامین نا تکمیل</span>
            <div v-if="activeTab === 'incomplete'" class="active_line"></div>
          </div>
          <div style="width: 1px; height: 20px; background-color: #eee;"></div>
          <div 
            class="w-50 text-center py-3 cursor-pointer position-relative"
            @click="activeTab = 'completed'"
          >
            <span :class="activeTab === 'completed' ? 'text_color_theme bold' : 'text_color_gray'">مضامین تکمیل شده</span>
            <div v-if="activeTab === 'completed'" class="active_line"></div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="text-center mt-5">
        <p>در حال دریافت معلومات...</p>
      </div>

      <div v-else>
        <div v-if="currentList.length === 0" class="text-center mt-5 text_color_gray">
          موردی یافت نشد.
        </div>
        <div v-else>
          <div v-for="(item, index) in currentList" :key="index" class="d-flex align-items-center justify-content-between bg_white rounded-4 p-3 mb-3 shadow_box cursor-pointer" @click="goToLesson(item.content_id)">
            
            <div class="d-flex flex-column align-items-start">
              <div class="d-flex flex-wrap justify-content-start gap-1 mb-1">
                 <p class="bold">{{ item.lesson_title }}</p>
                 <p class="bold">{{ item.content_title }}</p>
              </div>
              <p class="text_color_gray font_small">{{ item.second_title }}</p>
            </div>

            <div class="d-flex align-items-center gap-2">
              <p class="text_color_gray font_small">{{ item.time || '00:00' }}</p>
              <div class="play_icon_container">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 5V19L19 12L8 5Z" fill="#5865F2"/>
                </svg>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'LessonsProgressView',
  data() {
    return {
      activeTab: 'incomplete',
      loading: false,
      completedLessons: [],
      incompleteLessons: []
    }
  },
  computed: {
    currentList() {
      return this.activeTab === 'completed' ? this.completedLessons : this.incompleteLessons
    }
  },
  mounted() {
    this.fetchProgress()
  },
  methods: {
    async fetchProgress() {
      this.loading = true
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          user_id: userId
        })

        const response = await apiClient.post('/lessons_progress', formData)

        if (response.data.status === 'ok' && response.data.data) {
          this.completedLessons = response.data.data.completed_lessons || []
          this.incompleteLessons = response.data.data.incomplete_lessons || []
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    goToLesson(id) {
      if(id) {
        this.$router.push({ name: 'LessonDetail', params: { id: id } })
      }
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.active_line {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  height: 3px;
  background-color: #5865F2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.play_icon_container {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 1px solid #5865F2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.font_small {
  font-size: 0.85rem;
}
</style>